<template>
  <v-dialog
    v-model="visible"
    @keydown.enter="onSubmit"
  >
    <v-card>
      <v-card-title class="text-h6 secondary--text text-center">
        Вы уверены, что хотите выполнить операцию?
      </v-card-title>
      <v-divider />
      <v-card-actions class="py-4">
        <v-btn
          color="error lighten-1"
          class="mr-auto"
          large
          elevation="0"
          @click="close"
        >
          Отмена
        </v-btn>
        <v-btn
          color="success"
          large
          elevation="0"
          @click="onSubmit"
        >
          Подтвердить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ConfirmationModal',
  props: {
    value: Boolean,
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    close() {
      this.visible = false;
    },
    async onSubmit() {
      this.$emit('submit');
      this.close();
    },
  },
};
</script>
